import React from "react";

const HomeTables = ({ tables }) => {
  return (
    <div className="home-tables-container">
      <div className="home-tables-container-header">
        <table>
          <thead>
            <tr>
              <th>Table Name</th>
              <th>Players</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tables.map((table) => (
              <tr key={table.id}>
                <td>{table.tableName}</td>
                <td>{table.players.length}/5</td>
                <td>
                  <button>Join</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HomeTables;
